/* @flow weak */

'use strict';

const Omniture = {
  details: {
    currentQuestionGroup: 0,
    maxQuestionGroups: 0,
    questionGroup: ""
  },

  questionDetails: function(currentQuestionGroup, maxQuestionGroups, questionGroup) {

    this.details.currentQuestionGroup = currentQuestionGroup;
    this.details.maxQuestionGroups = maxQuestionGroups;
    this.details.questionGroup = questionGroup;

    this.accordionTracking();

  },

  omniture: function(s_omni) {

    var omni = {
        "adid": s_omni.getQueryParam('adid'),
        "fbref": s_omni.getQueryParam('fb_ref'),
        "sourceid": s_omni.getQueryParam('sourceid'),
        "povid": s_omni.getQueryParam('povid'),
        "findingMethod": s_omni.getQueryParam('findingMethod'),
        getCampaignId: function() {
            if (this.adid) {
                return this.adid;
            } else if (this.fbref) {
                return this.fbref.split('_')[1];
            } else if (this.sourceid) {
                return this.sourceid;
            } else {
                return '';
            }
        }
    };
    s_omni.campaign = omni.getCampaignId();
    var s_code = s_omni.t();
    if (s_code) {
        document.write(s_code);
    }

  },

  accordionTracking: function() {

    if (typeof s_omni !== 'undefined' && s_omni) {
        s_omni.pageName = "Commemorative Brands: " +
            this.details.questionGroup + " Personalized " +
            this.details.currentQuestionGroup + " of " + this.details.maxQuestionGroups;
        s_omni.channel = "classrings.walmart.com"; // Channel – Set to the domain
        s_omni.prop1 = "Personalize"; // Page Type
        s_omni.prop2 = "Commemorative Brands: " +
            this.details.questionGroup + " Personalized " +
            this.details.currentQuestionGroup + " of " + this.details.maxQuestionGroups;
        s_omni.prop8 = "Home"; // Department

        this.omniture(s_omni);
    }
  },

  addToCartTracking: function(productId, quantity, price) {

    if (typeof s_omni !== 'undefined' && s_omni) {
        s_omni.events = "scAdd,event116";
        s_omni.pageName = "Add to Cart Personalized Gifts";
        s_omni.prop1 = "Cart";
        s_omni.prop2 = "Add to Cart Personalized Gifts";
        s_omni.eVar5 = "Personalize Page";
        s_omni.eVar33 = quantity; // Number of item(s)
        s_omni.prop42 = "Checkout";
        s_omni.prop50 = "com";
        s_omni.products = "walmarthome;" + productId + ";" + quantity + ";" + price + ";eVar30=Walmart.com";

        this.omniture(s_omni);
    }

  },

  errorTracking: function(errorMessage) {

    if (typeof s_omni !== 'undefined' && s_omni) {
        s_omni.pageName = "Commemorative Brands: " +
            this.details.questionGroup + " Personalized " +
            this.details.currentQuestionGroup + " of " + this.details.maxQuestionGroups + ": Error"; // Page Title
        s_omni.channel = "classrings.walmart.com"; // Channel – Set to the domain
        s_omni.prop1 = "Error"; // Page Type
        s_omni.prop2 = "Commemorative Brands: " +
            this.details.questionGroup + " Personalized " +
            this.details.currentQuestionGroup + " of " + this.details.maxQuestionGroups + ": Error"; // Page Name Granular
        s_omni.prop48 = "Personalize: " + errorMessage; // Site Errors

        this.omniture(s_omni);
    }
  }

};

module.exports = Omniture;


// WEBPACK FOOTER //
// ./src/base/scripts/metrics/walmart/Omniture.js